<template>
  <div>
    <section>
      <div class="inner row5">
        <article class="infoInner">
          <AdminCorpProfile />
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import AdminCorpProfile from "@/components/join/admin/AdminCorpProfile";

export default {
  name: "CorpProfile",
  components: {
    AdminCorpProfile,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.infoInner > .infoTitle {
  padding: 0 100px;
}
.infoInner > div > h1 {
  color: #9e1915;
}
input:disabled {
  color: #7d7d7d;
}
.profileImgBox {
  padding: 40px 0;
  text-align: center;
}
.profileImgInputBox {
  position: relative;
}
.profileImgInputBox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.profileImgInputBox label:active {
  transform: scale(0.97);
}
.profileImgInputBox label {
  position: absolute;
  z-index: 1;
  width: 190px;
  height: 190px;
  color: #fff;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: transparent;
  cursor: pointer;
  left: 50%;
  margin-left: -95px;
}
.profileImgInputBox .upload-name {
  border: 0;
  display: inline-block;
  width: 190px;
  height: 190px;
  padding: 6px 20px 5px; /* label의 패딩값과 일치 */
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  vertical-align: middle;
  background: url("../../assets/images/user/imgEnroll.png");
  -webkit-appearance: none; /* 네이티브 외형 감추기 */
  -moz-appearance: none;
  appearance: none;
}
/* preview img */
.filebox .upload-display {
  /* 이미지가 표시될 지역 */
  margin-bottom: 5px;
}
@media (min-width: 768px) {
  .filebox .upload-display {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 0;
  }
}
.filebox .upload-thumb-wrap {
  /* 추가될 이미지를 감싸는 요소 */
  display: inline-block;
  width: 54px;
  padding: 2px;
  vertical-align: middle;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
}
.filebox .upload-display img {
  /* 추가될 이미지 */
  display: block;
  max-width: 100%;
  width: 100% \9;
  height: auto;
}
</style>

<style scoped lang="scss">
.bspRadio ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}
.bspSelectBox ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
</style>
